import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[NumberOnly]',
})
export class NumberOnlyDirective {
  // Removed this, in order to accepts only numbers
  // private regex: RegExp = new RegExp(/^[0-9]+(\.[0-9]*){0,1}$/g);
  // Allow decimal numbers. The \. is only allowed once to occur

  private regex: RegExp = new RegExp(/^[0-9]+([0-9]*){0,1}$/g);

  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: any = ['Backspace', 'Tab', 'End', 'Home'];

  constructor(private el: ElementRef) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    // Allow Backspace, tab, end, paste, and home keys
    if (
      this.specialKeys.indexOf(event.key) !== -1 ||
      (event.code === 'KeyV' && (event.metaKey || event.ctrlKey)) ||
      (event.code === 'KeyA' && (event.metaKey || event.ctrlKey))
    ) {
      return;
    }

    // Do not use event.keycode this is deprecated.
    // See: https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode
    const current: string = this.el.nativeElement.value;
    // We need this because the current value on the DOM element
    // is not yet updated with the value from this event
    const next: string = current.concat(event.key);
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }
}
